import styles from "./button.module.css";

const Button = ({ text, icon, variation, size, loading, disabled, onClick, styling }) => {
  return (
    <button style={styling} onClick={onClick} disabled={loading || disabled} className={`${styles.button} ${styles[variation]} ${styles[size]} ${(disabled || loading) && styles.disabled}`}>
      {!loading ? (
        <>
          {icon && <img src={icon} alt="Icone" />}

          {text}
        </>
      ) : (
        <div className={styles.spinner}></div>
      )}
    </button>
  );
};

export default Button;
